import * as React from 'react';

import { Icon } from '@/shared/types/icon';

const TwilioVoice = ({ size = 24, ref, ...props }: Icon & { ref?: React.Ref<SVGSVGElement> }) => {
  return (
    <svg
      {...props}
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 72 72"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M8 72h56a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8Z"
          fill="#F22F46"
        />
        <path
          d="M36 14c12.15 0 22 9.85 22 22s-9.85 22-22 22-22-9.85-22-22 9.85-22 22-22zm0 6.5c-8.56 0-15.5 6.94-15.5 15.5s6.94 15.5 15.5 15.5 15.5-6.94 15.5-15.5-6.94-15.5-15.5-15.5zm5.5 6.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm-11 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm11 8a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm-11 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
};

export default TwilioVoice;
